import React, { useState, createContext, useMemo, useCallback } from 'react'
import { iStepStoryUpload } from './index'
import Component from './Component'

// @ts-ignore
export const StepStoryUploadContext = createContext<{
  actions: {
    open: () => void
    close: () => void
  }
  store: iStepStoryUpload
}>({
  // @ts-ignore
  actions: {},
  store: {
    isOpen: false
  }
})

export const StepStoryUploadProvider: React.FC = ({ children }) => {
  const [stepStoryUpload, setStepStoryUpload] = useState<iStepStoryUpload>({
    isOpen: false
  })

  const open = useCallback(() => {
    setStepStoryUpload({
      isOpen: true
    })
  }, [])

  const close = useCallback(() => {
    setStepStoryUpload({
      isOpen: false
    })
  }, [])

  const value = useMemo(
    () => ({
      actions: { open, close },
      store: stepStoryUpload
    }),
    [open, close, stepStoryUpload]
  )

  return (
    <StepStoryUploadContext.Provider value={value}>
      <Component />
      {children}
    </StepStoryUploadContext.Provider>
  )
}
